export default __webpack_public_path__ + "../staticImages/lagerverkauf_jubi-260.png";